import React from 'react';

const badges = [
  {
    title: 'Built for Africa. Ready for the world.',
    text: 'Ghana-based, globally minded. We build with the African digital economy in mind without limiting our ambition to it.',
  },
  {
    title: 'Full-stack from idea to infrastructure.',
    text: 'Software, AI, APIs, systems architecture, we handle the whole thing, not just a slice of it.',
  },
  {
    title: 'We ship working software.',
    text: 'No vaporware. No endless roadmaps. We build it, we test it, we deliver it.',
  },
];

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about__grid">
        <div className="about__heading reveal-left">
          <div className="about__label">{'// WHO WE ARE'}</div>
          <h2>We're 200 OK Studios.</h2>
        </div>

        <div className="about__content">
          <p className="about__text reveal reveal-delay-1">
            Named after the HTTP status code that means success, we thought it
            was the right name for a company built around one core obsession:
            making things work, reliably, every single time.
          </p>
          <p className="about__text reveal reveal-delay-2">
            We're a technology studio based in Accra, Ghana. We design, build,
            and ship software that solves real problems for real people, from
            Accra to London to anywhere digital work happens.
          </p>
          <p className="about__text reveal reveal-delay-3">
            We're not a big agency. We're not a faceless platform. We're builders
            who care deeply about getting it right, the first time, every time.
          </p>
        </div>
      </div>

      <div className="about__badges">
        {badges.map((b, i) => (
          <div className={`about__badge reveal reveal-delay-${i + 1}`} key={i}>
            <span className="about__badge-icon">✓</span>
            <div>
              <h4 className="about__badge-title">{b.title}</h4>
              <p className="about__badge-text">{b.text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default About;
